import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store, persistor } from 'store';
import { MuiThemeProvider, StyledEngineProvider, color } from '@kis-technologies/kis-ui';
import theme from './theme';
import * as serviceWorker from './serviceWorker';
import Routes from 'routes';
import { PersistGate } from 'redux-persist/integration/react';
import 'assets/fonts/fonts.css';

document.documentElement.style.backgroundColor = color.X_LIGHT_GRAY;
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <StyledEngineProvider injectFirst>
            <MuiThemeProvider theme={theme}>
              <Routes />
            </MuiThemeProvider>
          </StyledEngineProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
